<template>
  <Calculatorv100 :edit="edit"/>
</template>

<script>

export default {
  name: "Calculatorv101",
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>

</style>